exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2IbZ2AehDtrpDsDRGcV-3g .custom-control.custom-radio .custom-control-input:checked ~ .custom-control-indicator{background-color:dycolor-internal(!button-background,@primary);border-color:dycolor-internal(!button-background,@primary)}\n", ""]);

// exports
exports.locals = {
	"root": "_2IbZ2AehDtrpDsDRGcV-3g"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/auto-publish-box/AutoPublishBox.scss
// module id = 881
// module chunks = 1